var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "viewport",
      staticClass: "RbVLFS_Viewport",
      style: { height: _vm.height },
      attrs: { id: _vm.id },
      on: {
        scroll: function ($event) {
          return _vm.handleScroll($event)
        },
      },
    },
    [
      _c("div", { staticClass: "heading" }, [_vm._t("heading")], 2),
      _c(
        "div",
        {
          ref: "contents",
          staticClass: "contents",
          style: {
            "padding-top": _vm.top + "px",
            "padding-bottom": _vm.bottom + "px",
          },
        },
        [
          _vm._l(_vm.visible, function (row) {
            return [
              _c(
                "div",
                { key: row.index, staticClass: "listRow" },
                [
                  _vm._t(
                    "default",
                    function () {
                      return [_vm._v("Missing Template")]
                    },
                    { row: row.data }
                  ),
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
      _c("div", { staticClass: "footer" }, [_vm._t("footer")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }